module.exports = __webpack_public_path__ + "assets/img/case2.ccb76b64.png";